export default {
  // 当前企业id
  companyId: state => {
    let id = state.userInfo.user_info ? JSON.parse(state.userInfo.user_info).user_id : '';
    return id ? id.substr(id.indexOf('&&') + 2) : '';
  },
  // isAdmin: state => {
  //     return state.menuTop.find(item => item.name==='系统设置')
  // },
};
